import PropTypes from 'prop-types';
import React from 'react';
import { Markup } from 'interweave';
import styles from './index.scss';

const GoalEntry = ({ iconSrc, iconUrl, iconAlt, description }) => {
  return (
    <div className={styles.goalEntry} data-testid="goal-entry">
      <div className={styles.media}>
        {/* Left Logo Badge */}
        <div className={styles.mediaLeft}>
          <a href={iconUrl}>
            <img className={styles.icon} src={iconSrc} alt={iconAlt} />
          </a>
        </div>

        {/* Right Main Body */}
        <div className={styles.mediaBody}>
          <div className={styles.entryTitle} data-testid="goal-description">
            <Markup noWrap={true} content={description} />
          </div>
        </div>
      </div>
    </div>
  );
};

GoalEntry.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default GoalEntry;
